import React from 'react';

import { MultiLineCell, TextCell } from './MainStyledComponents';

/**
 * Celda de PK de un listado.
 *
 * Con UN solo valor añade el sufijo « km» exactamente como siempre (genéricas,
 * campañas y los recorridos de una sola carretera no notan nada). Con VARIOS
 * —un recorrido multi-carretera apila un PK por carretera— se pinta tal cual:
 * el sufijo colgaría solo del último y leería como si los demás no tuvieran
 * unidad.
 *
 * 🔴 Vive aquí, y no dentro de una tabla, porque el MISMO dato se pinta en dos
 * listados distintos: la Vista general del recorrido (`InputRadioTagTable`) y
 * Recorridos Históricos (`CheckBoxTagTable`). Los dos salen de
 * `useSurveillanceRoutesListing`, o sea que reciben el mismo texto con saltos
 * de línea; hasta el 2026-08-24 solo el primero sabía respetarlos y el
 * histórico los aplastaba en una línea — «82+800 234+000 km», con la unidad
 * pegada al último y sin poder decir qué kilómetro es de qué carretera.
 */
export const PkCell = ({ value }: { value: string }): JSX.Element => {
  const isMultiLine = (value ?? '').includes('\n');
  return isMultiLine ? (
    <MultiLineCell size={'S'}>{value}</MultiLineCell>
  ) : (
    <TextCell size={'S'}>{`${value} km`}</TextCell>
  );
};

export default PkCell;
